// extracted by mini-css-extract-plugin
export default {"button6":"Button_button6__fUSTY"};